export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
export const UPDATE_DASHBOARD_SLIDES = 'UPDATE_DASHBOARD_SLIDES';
export const RESET_DASHBOARD = 'RESET_DASHBOARD';
